// extracted by mini-css-extract-plugin
export var tabpanel = "Tabs-module--tabpanel--3i0hm";
export var appBar = "Tabs-module--appBar--SIxfC";